import type { IconNode } from '../types';

/**
 * @name ice-hockey
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgNHY0YzAgMS4xLTEuOCAyLTQgMnMtNC0uOS00LTJWNCIgLz4KICA8ZWxsaXBzZSBjeD0iNiIgY3k9IjQiIHJ4PSI0IiByeT0iMiIgLz4KICA8cGF0aCBkPSJNNCAxN2EyIDIgMCAwIDAtMiAydjFhMiAyIDAgMCAwIDIgMmg0YTYgNiAwIDAgMCA1LjItM2w4LjUtMTRhMS45NCAxLjk0IDAgMSAwLTMuNC0ybC03LjkgMTNjLS40LjYtMSAxLTEuNyAxWiIgLz4KICA8cGF0aCBkPSJtMjAuNiA2LjgtMy4zLTIuMSIgLz4KICA8cGF0aCBkPSJtMTUuMiA4LjEgMy4zIDIuMSIgLz4KICA8cGF0aCBkPSJNNiAxN3Y1IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/ice-hockey
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const iceHockey: IconNode = [
  ['path', { d: 'M10 4v4c0 1.1-1.8 2-4 2s-4-.9-4-2V4', key: '1w9b51' }],
  ['ellipse', { cx: '6', cy: '4', rx: '4', ry: '2', key: '1nnr4b' }],
  [
    'path',
    {
      d: 'M4 17a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h4a6 6 0 0 0 5.2-3l8.5-14a1.94 1.94 0 1 0-3.4-2l-7.9 13c-.4.6-1 1-1.7 1Z',
      key: 'e88vg5',
    },
  ],
  ['path', { d: 'm20.6 6.8-3.3-2.1', key: 'ti4ez2' }],
  ['path', { d: 'm15.2 8.1 3.3 2.1', key: '2lrn57' }],
  ['path', { d: 'M6 17v5', key: '1sqdq9' }],
];

export default iceHockey;
